import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const { t } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-dark-900/95 backdrop-blur-lg border-b border-white/10' : 'bg-transparent'
    }`}>
      <nav className="container-custom mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_tech-consulting-1/artifacts/fne2dgjf_ChatGPT%20Image%2026%20aou%CC%82t%202025%20a%CC%80%2014_49_28.png" 
              alt="Winstep FZE Logo" 
              className="h-12 w-12 object-contain animate-float"
            />
            <div className="text-2xl font-bold glow-text">
              WINSTEP FZE
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-300 hover:text-white transition-colors duration-300 font-medium"
            >
              {t('nav.services')}
            </button>
            <button 
              onClick={() => scrollToSection('case-studies')}
              className="text-gray-300 hover:text-white transition-colors duration-300 font-medium"
            >
              {t('nav.caseStudies')}
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-300 hover:text-white transition-colors duration-300 font-medium"
            >
              {t('nav.about')}
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-gray-300 hover:text-white transition-colors duration-300 font-medium"
            >
              {t('nav.contact')}
            </button>
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <button 
              onClick={() => scrollToSection('contact')}
              className="btn-primary btn-hover-effect"
            >
              {t('nav.getQuote')}
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-white p-2"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 w-full bg-dark-900/95 backdrop-blur-lg border-b border-white/10">
            <div className="px-4 py-6 space-y-4">
              <button 
                onClick={() => scrollToSection('services')}
                className="block text-gray-300 hover:text-white transition-colors duration-300 font-medium"
              >
                {t('nav.services')}
              </button>
              <button 
                onClick={() => scrollToSection('case-studies')}
                className="block text-gray-300 hover:text-white transition-colors duration-300 font-medium"
              >
                {t('nav.caseStudies')}
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="block text-gray-300 hover:text-white transition-colors duration-300 font-medium"
              >
                {t('nav.about')}
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="block text-gray-300 hover:text-white transition-colors duration-300 font-medium"
              >
                {t('nav.contact')}
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="btn-primary w-full mt-4"
              >
                {t('nav.getQuote')}
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;